/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Panel_LayoutInputs */

const cs_builder_panel_layout = /** @type {(inputs: Builder_Panel_LayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozložení`)
};

const en_builder_panel_layout = /** @type {(inputs: Builder_Panel_LayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Layout`)
};

/**
* | output |
* | --- |
* | "Layout" |
*
* @param {Builder_Panel_LayoutInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_panel_layout = /** @type {((inputs?: Builder_Panel_LayoutInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Panel_LayoutInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_panel_layout(inputs)
	return cs_builder_panel_layout(inputs)
});